import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// The site used HashRouter until the A2P 10DLC fix, so links like
// https://lajdigital.com/#/terms are already in the wild (and in Twilio's
// campaign submission). Rewrite them to the real path before React mounts, so
// BrowserRouter sees the right location on first render and nothing 404s.
const legacyHash = window.location.hash;
if (legacyHash.startsWith('#/')) {
  const target = legacyHash.slice(1) || '/';
  window.history.replaceState(null, '', target + window.location.search);
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
